import { create } from 'zustand'

export const useOrganizationsStore = create(set => ({
  searchTerm: '',
  inputValue: '',
  owners: [],
  name: '',
  image_url: '',
  setSearchTerm: newText => set({ searchTerm: newText }),
  setInputValue: newText => set({ inputValue: newText }),
  setName: name => set({ name }),
  setLogo: image_url => set({ image_url }),
  setOwners: owners => set({ owners }),
}))
